import React from "react";
import Pro from "../../../assets/Profile.png";
import { ImUpload } from "react-icons/im";
import Diamond from "../../../assets/Diamond.png";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TeacherProfile = () => {
  const { t } = useTranslation();

  // const [Profile]= useState([
  //     {
  //       name:'Edit Profile',
  //       path:''
  // },
  //     {
  //       name:'Edit Student',
  //       path:''
  // },

  // ])

  return (
    <div>
      <div className="flex items-center xl:p-5 sm:p-0 justify-center pb-12 ">
        <div className="flex flex-wrap w-full justify-center border rounded-3xl shadow-xl pb-12">

          <div className=" w-full xl:w-1/3 p-4 ">
            {/* content1 */}
            <div className="flex flex-col  items-center justify-center">
              <div className="">
                <img
                  className="rounded-full border w-40 h-40"
                  src={Pro}
                  alt=""
                />
              </div>
              <div className="flex justify-end relative left-16 -top-6">
                <ImUpload className="w-5 h-5" />
              </div>
            </div>
            {/* content2 */}

            <div className="flex items-center justify-center text-4xl font-semibold">
              <p>Irfan Ahsan</p>
            </div>
            {/* content3 */}

            <div className="flex items-center justify-center text-xl mt-5 font-medium text-[#979CA5]">
              <p>{t("adminDash.teacherCard.mentor")}</p>
            </div>
            {/* content4 */}

            <div className="flex items-center justify-center ">
              <Link to='.././mentor-dash'>
                <button className="border bg-[#5653FC] text-white text-xl font-medium rounded-lg px-8 py-3 mt-5"> {t("adminDash.paymentDetail.goToDashboard")}
                </button>
              </Link>
            </div>
            <div className="mx-4">
              <hr className="h-0.5 mt-4 bg-[#979CA5]" />
            </div>
            {/* content5 */}
            <div className="mt-3 mx-4 text-2xl font-semibold">
              <p>{t("adminDash.paymentDetail.accountSetting")}</p>
            </div>
            {/* content6 */}
            <div className="mx-8 xl:block md:flex md:flex-wrap md:justify-center md:gap-8 cursor-pointer">
              {/* {Profile &&
             Profile.map((data) =>( */}

              <NavLink to=''>
                <div className="  flex items-center  bg-blue-50  border-l-4 border-[#5963F5]  text-black text-sm font-medium rounded-lg px-6 space-x-2 py-2.5 mt-5">
                  <img src={Diamond} alt="" /> <p>{t("adminDash.paymentDetail.editProfile")}</p>
                </div>
              </NavLink>
              {/* ))} */}


              <NavLink to=''>
                <div className=" flex items-center border-l-4 border-[#5963F5]  bg-blue-50 text-black text-sm font-medium rounded-lg px-6 space-x-2 py-2.5 mt-5">
                  <img src={Diamond} alt="" /> <p>{t("adminDash.studentPayment.myStudents")}</p>
                </div>
              </NavLink>

              <NavLink to='../teacher-notification'>
                <div className=" flex items-center border-l-4 border-[#5963F5]  bg-blue-50 text-black text-sm font-medium rounded-lg px-6 space-x-2 py-2.5 mt-5">
                  <img src={Diamond} alt="" /> <p>{t("adminDash.notifications")}</p>
                </div>
              </NavLink>
            </div>

            {/* content7 */}
            <div className="mt-14 mx-4 text-2xl font-semibold ">
              <p>{t("adminDash.paymentDetail.mySubscription")}</p>
            </div>
            {/* content8 */}


            <div className="mx-8 xl:block md:flex md:flex-wrap md:justify-center md:gap-8 cursor-pointer">
              <NavLink to='../teacher-payment'>
                <div className=" flex items-center border-l-4  border-[#5963F5]  bg-blue-50 text-black text-sm font-medium rounded-lg px-6 space-x-2 py-2.5 mt-5">
                  <img src={Diamond} alt="" /> <p>{t("adminDash.paymentDetail.payments")}</p>
                </div>
              </NavLink>

              <NavLink to=''>
                <div className=" flex items-center border-l-4  border-[#5963F5]  bg-blue-50 text-black text-sm font-medium rounded-lg px-6 space-x-2 py-2.5 mt-5">
                  <img src={Diamond} alt="" /> <p>{t("adminDash.paymentDetail.invoices")}</p>
                </div>
              </NavLink>

            </div>
          </div>

          <div className="w-full xl:w-2/3 p-4 border-l-2 ">
            {/* content1 */}
            <div className="mx-4 mt-12">
              <p className="text-2xl font-bold">{t("adminDash.stuProfile.profileDetails")}</p>
              <p className="text-sm font-medium">
                {t("adminDash.portfolio.loremLong")}
              </p>
            </div>
            <div className="mx-4">
              <hr className="h-0.5 mt-4 bg-[#979CA5]" />
            </div>
            {/* content2 */}

            <div className="w-full mt-12">
              <form className="grid grid-cols-1 sm:grid-cols-2 gap-4 mx-12" action="">
                <div>
                  <input type="text" placeholder={t("adminDash.stuProfile.firstName")} className="border h-10 w-full rounded-lg px-4 bg-gray-50 focus:border-blue-500 focus:outline-none" />
                </div>
                <div>
                  <input type="text" placeholder={t("adminDash.stuProfile.lastName")} className="border h-10 w-full rounded-lg px-4 bg-gray-50 focus:border-blue-500 focus:outline-none" />
                </div>
                <div>
                  <input type="text" placeholder={t("adminDash.stuProfile.email")} className="border h-10 w-full rounded-lg px-4 bg-gray-50 focus:border-blue-500 focus:outline-none" />
                </div>
                <div>
                  <input type="text" placeholder={t("adminDash.teacherProfile.hourlyRate")} className="border h-10 w-full rounded-lg px-4 bg-gray-50 focus:border-blue-500 focus:outline-none" />
                </div>
                <div>
                  <input type="text" placeholder={t("adminDash.stuProfile.country")} className="border h-10 w-full rounded-lg px-4 bg-gray-50 focus:border-blue-500 focus:outline-none" />
                </div>
                <div>
                  <input type="text" placeholder={t("adminDash.stuProfile.city")} className="border h-10 w-full rounded-lg px-4 bg-gray-50 focus:border-blue-500 focus:outline-none" />
                </div>
                <div>
                  <input type="text" placeholder={t("adminDash.stuProfile.zip")} className="border h-10 w-full rounded-lg px-4 bg-gray-50 focus:border-blue-500 focus:outline-none" />
                </div>
                <div>
                  <input type="text" placeholder={t("adminDash.stuProfile.address")} className="border h-10 w-full rounded-lg px-4 bg-gray-50 focus:border-blue-500 focus:outline-none" />
                </div>
              </form>
            </div>

            <div>
              <p className="border border-blue-500 w-fit p-2 rounded-lg mt-8 font-medium mx-12 cursor-pointer">{t("adminDash.stuProfile.updateProfile")}</p>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default TeacherProfile;
